import {auth} from "../../store/auth.store";
import paths from "../../paths";
import {userLogout} from "../../services/auth.service";
import React from "react";
import {toast} from "react-toastify";

export function MemberAccount() {

    return <>
        <div className="mobile-menu-wrapper">
            {auth.authentication && <div className={"profile-info"}>
                <svg width="64" height="64" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="78" height="78" rx="39" fill="#F0F1EC"></rect>
                    <rect x="1" y="1" width="78" height="78" rx="39" stroke="#1F3735" strokeWidth="2"></rect>
                    <ellipse
                        cx="39.9997"
                        cy="49.1667"
                        rx="11.6667"
                        ry="5.83333"
                        stroke="#1F3735"
                        strokeWidth="3"
                        strokeLinejoin="round"
                    ></ellipse>
                    <ellipse
                        cx="40.0002"
                        cy="31.6667"
                        rx="6.66667"
                        ry="6.66667"
                        stroke="#1F3735"
                        strokeWidth="3"
                        strokeLinejoin="round"
                    ></ellipse>
                </svg>
                <div className={"d-flex flex-column"}>
                    <div className={"member-name"}>
                        {auth.member.first_name} {auth.member.last_name}
                    </div>
                    <div className={"member-id d-flex align-items-center"}>
                        <div>
                            ID No: {auth.member.id}
                        </div>

                        <div className={"ms-1"} onClick={() => {
                            navigator.clipboard.writeText(auth.member.id.toString()).then(() => {
                                toast.success("Üye no kopyalandı.");
                            });
                        }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect x="4.23779" y="2.08345" width="5.67949" height="5.68011" rx="1.25"
                                      stroke="#9CAFAE" strokeWidth="1.5">
                                </rect>
                                <path
                                    d="M7.84632 9.23151V9.23151C7.84632 10.0246 7.20339 10.6675 6.41029 10.6675H3.3335C2.22893 10.6675 1.3335 9.7721 1.3335 8.66753V5.59004C1.3335 4.79702 1.97637 4.15414 2.76939 4.15414V4.15414"
                                    stroke="#9CAFAE" strokeWidth="1.5">
                                </path>
                            </svg>

                        </div>
                    </div>
                </div>
            </div>}
            {auth.authentication && <div className="balance-wrapper-mobile">
                <div className="menu-balance-left">
                    <p className="text-xsmall default fw-regular text-white w-100">Hesap Bakiyem</p>
                    <p className="member-balance">{auth.member.balance_debit}₺</p>
                </div>
                <div className="menu-balance-right">
                    <p className="text-xsmall default fw-regular text-white w-100 text-end">Puan Bakiyem</p>
                    <p className="member-balance text-end">{auth.member.balance_point}</p>
                </div>
            </div>}
            <ul className="p-0">
                <li className="mobile-menu-button-wrapper">
                    <a className="mobile-menu-item-link" title="Ana Sayfa" href={paths.home.url}>
                        <p className="text-md text-bold">Ana Sayfa</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a title="Bahis Yap"
                       className="mobile-menu-item-link"
                       href={paths.betting.url}>
                        <p className="text-md text-bold">Bahis Yap</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a title="Kuponlarım"
                       className="mobile-menu-item-link"
                       href={paths.memberTickets.url}>
                        <p className="text-md text-bold">Kuponlarım</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a title="Sonuçlar"
                       className="mobile-menu-item-link"
                       href={paths.results.url}>
                        <p className="text-md text-bold">Sonuçlar</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a title="CANLI TV"
                       className="mobile-menu-item-link"
                       href={paths.stream.url}>
                        <p className="text-md text-bold">CANLI TV</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a title="Muhtemeller"
                       className="mobile-menu-item-link"
                       href={paths.possibles.url}>
                        <p className="text-md text-bold">Muhtemeller</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a title="Program"
                       className="mobile-menu-item-link"
                       href={paths.program.url}>
                        <p className="text-md text-bold">Program</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a title="Yazar Yorumları"
                       className="mobile-menu-item-link"
                       href={paths.tipsterComments.url}>
                        <p className="text-md text-bold">Yazar Yorumları</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a title="AGF"
                       className="mobile-menu-item-link"
                       href={paths.agf.url}>
                        <p className="text-md text-bold">AGF</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a
                        className="mobile-menu-item-link" title="Kampanyalar"
                        href={`${paths.campaigns.url}`}>
                        <p className="text-md text-bold">Kampanyalar</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a
                        className="mobile-menu-item-link" title="Hakkımızda"
                        href={`${paths.flatpage.url}/hakkimizda`}>
                        <p className="text-md text-bold">Hakkımızda</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>

            </ul>
            {auth.authentication && <ul className={"p-0"}>
                <div className="mobile-menu-title">
                    <p className="text-xsmall">BANKA İŞLEMLERİ</p>
                </div>
                <li className="mobile-menu-button-wrapper">
                    <a
                        className="mobile-menu-item-link" title="Para Yatır"
                        href={paths.deposit.url}>
                        <div className="d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                 viewBox="0 0 24 24"
                                 fill="none">
                                <path d="M17.9999 6L5.99994 18M5.99994 18H13.9999M5.99994 18V10"
                                      stroke="#1F3735" strokeWidth="2.76667" strokeLinecap="round"
                                      strokeLinejoin="round">
                                </path>
                            </svg>
                            <p className="text-md text-bold"
                            >Para Yatır</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a
                        className="mobile-menu-item-link" title="Para Çek"
                        href={paths.withdraw.url}>
                        <div className="d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                 viewBox="0 0 24 24"
                                 fill="none">
                                <path d="M6 18L18 6M18 6H10M18 6V14" stroke="#1F3735" strokeWidth="3.32"
                                      strokeLinecap="round" strokeLinejoin="round">
                                </path>
                            </svg>
                            <p className="text-md text-bold"
                            >Para Çek</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a
                        className="mobile-menu-item-link" title="Banka Hesaplarım"
                        href={paths.memberBankAccounts.url}>
                        <div className="d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                 viewBox="0 0 20 20"
                                 fill="none">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M9.85443 1.69338C9.95131 1.68489 10.0487 1.68489 10.1456 1.69338C10.2571 1.70316 10.3633 1.72693 10.4477 1.74581L16.6589 3.12611C16.8259 3.1632 16.992 3.20007 17.1323 3.24226C17.289 3.28935 17.4672 3.35776 17.6409 3.48288C17.8862 3.65959 18.0788 3.8997 18.1981 4.17748C18.2826 4.37417 18.3107 4.56304 18.3227 4.72618C18.3334 4.87235 18.3334 5.04242 18.3334 5.2135V6.19338C18.3334 6.40363 18.3334 6.60846 18.3192 6.78187C18.3037 6.97237 18.267 7.19715 18.1517 7.42333C17.9919 7.73694 17.7369 7.99191 17.4233 8.15169C17.1972 8.26694 16.9724 8.30366 16.7819 8.31923C16.7448 8.32226 16.7063 8.32464 16.6667 8.32651V13.3402C16.7063 13.3421 16.7448 13.3444 16.7819 13.3475C16.9724 13.363 17.1972 13.3997 17.4233 13.515C17.7369 13.6748 17.9919 13.9298 18.1517 14.2434C18.267 14.4695 18.3037 14.6943 18.3192 14.8848C18.3334 15.0582 18.3334 15.2631 18.3334 15.4733V16.1934C18.3334 16.4037 18.3334 16.6085 18.3192 16.7819C18.3037 16.9724 18.267 17.1971 18.1517 17.4233C17.9919 17.7369 17.7369 17.9919 17.4233 18.1517C17.1972 18.2669 16.9724 18.3037 16.7819 18.3192C16.6084 18.3334 16.4036 18.3334 16.1933 18.3333H3.80678C3.59646 18.3334 3.39163 18.3334 3.21817 18.3192C3.02767 18.3037 2.80289 18.2669 2.57671 18.1517C2.2631 17.9919 2.00814 17.7369 1.84835 17.4233C1.7331 17.1971 1.69638 16.9724 1.68081 16.7819C1.66664 16.6084 1.66666 16.4036 1.66669 16.1932L1.66669 15.4734C1.66666 15.2631 1.66664 15.0583 1.68081 14.8848C1.69638 14.6943 1.7331 14.4695 1.84835 14.2434C2.00814 13.9298 2.2631 13.6748 2.57671 13.515C2.80289 13.3997 3.02767 13.363 3.21817 13.3475C3.25522 13.3444 3.2937 13.3421 3.33335 13.3402V8.3265C3.2937 8.32464 3.25522 8.32226 3.21817 8.31923C3.02767 8.30366 2.80289 8.26694 2.57671 8.15169C2.2631 7.9919 2.00814 7.73694 1.84835 7.42333C1.7331 7.19715 1.69638 6.97237 1.68081 6.78187C1.66664 6.60841 1.66666 6.40358 1.66669 6.19326L1.66669 5.21349C1.66667 5.04241 1.66665 4.87235 1.67738 4.72618C1.68936 4.56304 1.71747 4.37417 1.80194 4.17748C1.92124 3.8997 2.11384 3.65959 2.35913 3.48288C2.53281 3.35776 2.71109 3.28934 2.86774 3.24226C3.0081 3.20007 3.17412 3.1632 3.34113 3.12611L9.55237 1.74581C9.63673 1.72693 9.74299 1.70316 9.85443 1.69338ZM5.00002 8.33335V13.3333H7.08335V8.33335H5.00002ZM8.75002 8.33335V13.3333H11.25V8.33335H8.75002ZM12.9167 8.33335V13.3333H15V8.33335H12.9167Z"
                                      fill="#1F3735">
                                </path>
                            </svg>
                            <p className="text-md text-bold"
                            >Banka Hesaplarım</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a
                        className="mobile-menu-item-link" title="Hesap Hareketlerim"
                        href={paths.memberTransactions.url}>
                        <div className="d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                 viewBox="0 0 16 16"
                                 fill="none">
                                <path
                                    d="M13.3334 11.3333H2.66675M2.66675 11.3333L5.33341 8.66667M2.66675 11.3333L5.33341 14M2.66675 4.66667H13.3334M13.3334 4.66667L10.6667 2M13.3334 4.66667L10.6667 7.33333"
                                    stroke="#1F3735" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round">
                                </path>
                            </svg>
                            <p className="text-md text-bold"
                            >Hesap Hareketlerim</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
            </ul>}
            {auth.authentication && <ul className={"p-0"}>
                <div className="mobile-menu-title">
                    <p className="text-xsmall">SANA ÖZEL</p>
                </div>
                <li className="mobile-menu-button-wrapper">
                    <a
                        className="mobile-menu-item-link" title="Kampanyalarım"
                        href={paths.campaigns.url}>
                        <div className="d-flex">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="20" height="20" fill="#C9CAC5">
                                </rect>
                                <path
                                    d="M-226 -805C-226 -818.255 -215.255 -829 -202 -829H3287C3300.25 -829 3311 -818.255 3311 -805V674C3311 687.255 3300.25 698 3287 698H-202C-215.255 698 -226 687.255 -226 674V-805Z"
                                    fill="#D4D6CE">
                                </path>
                                <path
                                    d="M-202 -828H3287V-830H-202V-828ZM3310 -805V674H3312V-805H3310ZM3287 697H-202V699H3287V697ZM-225 674V-805H-227V674H-225ZM-202 697C-214.703 697 -225 686.703 -225 674H-227C-227 687.807 -215.807 699 -202 699V697ZM3310 674C3310 686.703 3299.7 697 3287 697V699C3300.81 699 3312 687.807 3312 674H3310ZM3287 -828C3299.7 -828 3310 -817.703 3310 -805H3312C3312 -818.807 3300.81 -830 3287 -830V-828ZM-202 -830C-215.807 -830 -227 -818.807 -227 -805H-225C-225 -817.703 -214.703 -828 -202 -828V-830Z"
                                    fill="black" fillOpacity="0.1">
                                </path>
                                <g clipPath="url(#clip0_2255_21215)">
                                    <rect width="375" height="1334" transform="translate(-26 -716)"
                                          fill="white">
                                    </rect>
                                    <rect x="-13.5" y="-14.5" width="350" height="49" rx="9.5"
                                          fill="white">
                                    </rect>
                                    <rect x="-13.5" y="-14.5" width="350" height="49" rx="9.5"
                                          stroke="#E8E6D0">
                                    </rect>
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M4.72465 4.16667C4.63188 3.90111 4.58338 3.61949 4.58338 3.33333C4.58338 2.67509 4.84005 2.04085 5.30161 1.5709C5.76366 1.10044 6.39357 0.833333 7.05361 0.833333C8.5492 0.833333 9.47716 1.84872 10 2.72686C10.5229 1.84872 11.4509 0.833333 12.9465 0.833333C13.6065 0.833333 14.2364 1.10044 14.6985 1.5709C15.16 2.04085 15.4167 2.67509 15.4167 3.33333C15.4167 3.61949 15.3682 3.90111 15.2754 4.16667L17.1054 4.16667C17.2805 4.16665 17.451 4.16664 17.5961 4.17653C17.7547 4.18736 17.9428 4.21275 18.1379 4.29354C18.5462 4.4627 18.8707 4.78715 19.0398 5.19553C19.1206 5.39057 19.146 5.57867 19.1569 5.73732C19.1668 5.8823 19.1667 6.05285 19.1667 6.22778V6.27223C19.1667 6.44715 19.1668 6.61771 19.1569 6.76269C19.146 6.92134 19.1206 7.10944 19.0398 7.30448C18.8707 7.71286 18.5462 8.03731 18.1379 8.20647C17.9428 8.28726 17.7547 8.31265 17.5961 8.32348C17.451 8.33337 17.2805 8.33336 17.1055 8.33334H2.89465C2.71961 8.33336 2.54909 8.33337 2.40402 8.32347C2.24538 8.31265 2.05728 8.28726 1.86224 8.20647C1.45386 8.03731 1.1294 7.71286 0.960248 7.30448C0.879461 7.10944 0.854067 6.92134 0.843242 6.76269C0.833348 6.61768 0.833361 6.44716 0.833375 6.27219V6.22787C0.833362 6.0529 0.833348 5.88233 0.843243 5.73732C0.854067 5.57867 0.879461 5.39057 0.960248 5.19553C1.1294 4.78715 1.45386 4.4627 1.86224 4.29354C2.05728 4.21275 2.24538 4.18736 2.40402 4.17653C2.54906 4.16664 2.71967 4.16665 2.89465 4.16667L4.72465 4.16667ZM7.05361 2.5C6.84539 2.5 6.64259 2.58408 6.49069 2.73875C6.33828 2.89392 6.25004 3.10752 6.25004 3.33333C6.25004 3.55914 6.33828 3.77275 6.49069 3.92792C6.64259 4.08259 6.84539 4.16667 7.05361 4.16667H8.86192C8.80159 4.02388 8.73218 3.87597 8.653 3.72939C8.24811 2.97984 7.72835 2.5 7.05361 2.5ZM11.1382 4.16667C11.1985 4.02388 11.2679 3.87597 11.3471 3.72939C11.752 2.97984 12.2717 2.5 12.9465 2.5C13.1547 2.5 13.3575 2.58408 13.5094 2.73875C13.6618 2.89392 13.75 3.10752 13.75 3.33333C13.75 3.55914 13.6618 3.77275 13.5094 3.92792C13.3575 4.08259 13.1547 4.16667 12.9465 4.16667H11.1382Z"
                                          fill="#1F3735">
                                    </path>
                                    <path
                                        d="M2.50005 10.8333C2.50005 10.3731 2.87314 10 3.33338 10H8.50004C8.7334 10 8.85008 10 8.93921 10.0454C9.01761 10.0854 9.08135 10.1491 9.1213 10.2275C9.16671 10.3166 9.16671 10.4333 9.16671 10.6667V18.5C9.16671 18.7334 9.16671 18.85 9.1213 18.9392C9.08135 19.0176 9.01761 19.0813 8.93921 19.1213C8.85008 19.1667 8.7334 19.1667 8.50004 19.1667H5.96784C5.52864 19.1667 5.14961 19.1667 4.83752 19.1412C4.50807 19.1143 4.18039 19.0548 3.86507 18.8942C3.39466 18.6545 3.01221 18.272 2.77253 17.8016C2.61187 17.4863 2.55244 17.1586 2.52552 16.8292C2.50002 16.517 2.50003 16.1381 2.50004 15.6988L2.50005 10.8333Z"
                                        fill="#1F3735">
                                    </path>
                                    <path
                                        d="M15.1626 19.1412C14.8504 19.1667 14.4714 19.1667 14.0321 19.1667H11.5C11.2667 19.1667 11.15 19.1667 11.0609 19.1213C10.9825 19.0813 10.9187 19.0176 10.8788 18.9392C10.8334 18.85 10.8334 18.7334 10.8334 18.5V10.6667C10.8334 10.4333 10.8334 10.3166 10.8788 10.2275C10.9187 10.1491 10.9825 10.0854 11.0609 10.0454C11.15 10 11.2667 10 11.5 10H16.6667C17.127 10 17.5 10.3731 17.5 10.8333V15.6988C17.5001 16.1381 17.5001 16.5171 17.4746 16.8292C17.4477 17.1586 17.3882 17.4863 17.2276 17.8016C16.9879 18.272 16.6054 18.6545 16.135 18.8942C15.8197 19.0548 15.492 19.1143 15.1626 19.1412Z"
                                        fill="#1F3735">
                                    </path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_2255_21215">
                                        <rect width="375" height="1334" fill="white"
                                              transform="translate(-26 -716)">
                                        </rect>
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="text-md text-bold">Kampanyalar</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
            </ul>}
            {auth.authentication && <ul className={"p-0"}>
                <div className="mobile-menu-title">
                    <p className="text-xsmall">AYARLAR</p>
                </div>
                <li className="mobile-menu-button-wrapper">
                    <a className="mobile-menu-item-link" title="Profil Ayarları"
                       href={paths.memberInfo.url}>
                        <div className="d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                 viewBox="0 0 20 20"
                                 fill="none">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M2.84845 15.2526C4.49259 13.0766 7.0824 11.6667 10 11.6667C12.9176 11.6667 15.5074 13.0766 17.1515 15.2526C17.159 15.2624 17.1664 15.2723 17.1739 15.2822C17.3153 15.4691 17.4669 15.6696 17.5752 15.863C17.7063 16.097 17.8035 16.3678 17.7975 16.6971C17.7926 16.9618 17.7124 17.2097 17.615 17.4053C17.5176 17.601 17.3683 17.8144 17.16 17.9778C16.8822 18.1958 16.5798 18.273 16.3111 18.3052C16.0754 18.3334 15.7961 18.3334 15.5153 18.3333C15.5026 18.3333 15.49 18.3333 15.4773 18.3333H4.52269C4.51004 18.3333 4.49738 18.3333 4.48473 18.3333C4.20389 18.3334 3.92457 18.3334 3.68887 18.3052C3.42021 18.273 3.11779 18.1958 2.84002 17.9778C2.63173 17.8144 2.48237 17.601 2.38498 17.4053C2.28758 17.2097 2.20738 16.9618 2.20254 16.6971C2.19651 16.3678 2.29369 16.097 2.4248 15.863C2.53312 15.6696 2.6847 15.4691 2.82606 15.2822C2.83356 15.2723 2.84102 15.2624 2.84845 15.2526Z"
                                      fill="#1F3735">
                                </path>
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M5.41667 6.24999C5.41667 3.71868 7.46869 1.66666 10 1.66666C12.5313 1.66666 14.5833 3.71868 14.5833 6.24999C14.5833 8.78129 12.5313 10.8333 10 10.8333C7.46869 10.8333 5.41667 8.78129 5.41667 6.24999Z"
                                      fill="#1F3735">
                                </path>
                            </svg>
                            <p className="text-md text-bold">Profil Ayarları</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a className="mobile-menu-item-link" title="İletişim Ayarları"
                       href={paths.notificationInfo.url}>
                        <div className="d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                 viewBox="0 0 20 20"
                                 fill="none">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M7.26612 4.76791C7.14802 4.4509 7.08335 4.10783 7.08335 3.75001C7.08335 2.13918 8.38919 0.833344 10 0.833344C11.6109 0.833344 12.9167 2.13918 12.9167 3.75001C12.9167 4.10783 12.852 4.4509 12.7339 4.7679C13.2222 4.99689 13.6767 5.28882 14.0813 5.63947C15.1852 6.59616 15.8334 7.92144 15.8334 9.33334C15.8334 11.0897 16.2669 12.3333 16.7773 13.1964L16.7858 13.2109C17.1139 13.7657 17.3703 14.1993 17.5422 14.5104C17.6281 14.666 17.7037 14.8101 17.7587 14.9336C17.7859 14.9948 17.816 15.0683 17.8394 15.1463C17.8569 15.2045 17.8999 15.3554 17.882 15.5383C17.8722 15.6387 17.8497 15.8381 17.7336 16.0417C17.6175 16.2452 17.4573 16.3661 17.3758 16.4256C17.2431 16.5227 17.1103 16.5643 17.0442 16.5826C16.9662 16.6042 16.8903 16.617 16.8274 16.6254C16.7017 16.6422 16.5553 16.6508 16.4027 16.6561C16.0985 16.6667 15.6732 16.6667 15.1372 16.6667H13.2283C12.8583 18.1044 11.5532 19.1667 10 19.1667C8.44682 19.1667 7.14174 18.1044 6.7717 16.6667H4.86294C4.327 16.6667 3.90156 16.6667 3.59736 16.6561C3.44477 16.6508 3.29837 16.6422 3.17264 16.6254C3.10975 16.617 3.03391 16.6042 2.95586 16.5826C2.88972 16.5643 2.75693 16.5227 2.62422 16.4256C2.54279 16.3661 2.3826 16.2452 2.26648 16.0417C2.15037 15.8381 2.12785 15.6387 2.11804 15.5383C2.10016 15.3554 2.14315 15.2045 2.16062 15.1463C2.18405 15.0683 2.21412 14.9948 2.24138 14.9336C2.29635 14.8101 2.37196 14.666 2.45789 14.5104C2.62979 14.1993 2.88609 13.7658 3.21424 13.2108L3.22277 13.1964C3.73315 12.3333 4.1667 11.0897 4.1667 9.33334C4.1667 7.92144 4.81486 6.59615 5.91872 5.63947C6.32331 5.28883 6.77787 4.99689 7.26612 4.76791ZM8.75002 3.75001C8.75002 3.05965 9.30966 2.50001 10 2.50001C10.6904 2.50001 11.25 3.05965 11.25 3.75001C11.25 3.93425 11.2105 4.10874 11.1392 4.26594C10.7657 4.20023 10.3842 4.16668 10 4.16668C9.61581 4.16668 9.2343 4.20023 8.86089 4.26594C8.78955 4.10874 8.75002 3.93425 8.75002 3.75001ZM10 17.5C10.6169 17.5 11.1555 17.1648 11.4437 16.6667H8.55632C8.8445 17.1648 9.38312 17.5 10 17.5Z"
                                      fill="#1F3735">
                                </path>
                            </svg>
                            <p className="text-md text-bold">İletişim Ayarları</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mobile-menu-button-wrapper">
                    <a className="mobile-menu-item-link" title="Sıkça Sorulan Sorular"
                       href={paths.supportFAQ.url}>
                        <div className="d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                 viewBox="0 0 20 20"
                                 fill="none" className="mr-2">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M10 0.833252C4.93743 0.833252 0.833374 4.93731 0.833374 9.99992C0.833374 15.0625 4.93743 19.1666 10 19.1666C15.0626 19.1666 19.1667 15.0625 19.1667 9.99992C19.1667 4.93731 15.0626 0.833252 10 0.833252ZM9.0889 6.89261C9.42823 6.69318 9.8272 6.62028 10.2151 6.68682C10.6031 6.75336 10.9549 6.95505 11.2084 7.25616C11.4619 7.55727 11.6006 7.93838 11.6 8.33198L11.6 8.33322C11.6 8.72416 11.2958 9.13173 10.7211 9.51484C10.4591 9.68949 10.1912 9.82404 9.98555 9.91546C9.88388 9.96064 9.80032 9.99401 9.74413 10.0154C9.71919 10.0249 9.69415 10.0341 9.66897 10.0429C9.23291 10.1888 8.99736 10.6604 9.1428 11.0967C9.28834 11.5334 9.76027 11.7693 10.1969 11.6238L10.3375 11.5729C10.418 11.5422 10.5297 11.4975 10.6624 11.4385C10.9255 11.3216 11.2826 11.1436 11.6456 10.9016C12.3208 10.4515 13.2663 9.60927 13.2667 8.33398C13.2678 7.54695 12.9903 6.78493 12.4835 6.18283C11.9765 5.5806 11.2728 5.17722 10.4969 5.04414C9.72103 4.91106 8.9231 5.05686 8.24443 5.45572C7.56576 5.85458 7.05015 6.48076 6.78892 7.22335C6.6362 7.65751 6.86434 8.13327 7.2985 8.286C7.73266 8.43872 8.20842 8.21058 8.36115 7.77642C8.49176 7.40513 8.74957 7.09204 9.0889 6.89261ZM10 13.3332C9.5398 13.3332 9.1667 13.7063 9.1667 14.1666C9.1667 14.6268 9.5398 14.9999 10 14.9999H10.0084C10.4686 14.9999 10.8417 14.6268 10.8417 14.1666C10.8417 13.7063 10.4686 13.3332 10.0084 13.3332H10Z"
                                      fill="#1F3735">
                                </path>
                            </svg>
                            <p className="text-md text-bold"
                            >Sıkça Sorulan Sorular</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                             fill="none">
                            <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round">
                            </path>
                        </svg>
                    </a>
                </li>
                <li className="mb-4 mobile-menu-button-wrapper" onClick={() => {
                    userLogout();
                }}>
                    <div className="d-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                             fill="none">
                            <path
                                d="M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6M6 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H6"
                                stroke="#1F3735" strokeWidth="2" strokeLinecap="round"
                                strokeLinejoin="round">
                            </path>
                        </svg>
                        <p className="text-md text-bold"
                        >Çıkış Yap</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                         fill="none">
                        <path d="M1 11L5 6L1 1" stroke="#353535" strokeWidth="1.5" strokeLinecap="round"
                              strokeLinejoin="round">
                        </path>
                    </svg>
                </li>
            </ul>}
        </div>
    </>

}
